export const formatMoney = (amount: number | null | undefined): string => {
    if (amount === null || amount === undefined) return '0';
    return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Math.round(amount));
};

export const parseMoney = (value: string): number => {
    // Remove currency symbol and thousand separators, keeping only digits
    const normalized = value.replace(/[^\d]/g, '');
    return parseInt(normalized) || 0;
};